define('model/GroupedTimeSlotsModel',['require','backbone'],function (require) {

    var Backbone = require('backbone');

    /**
     * Grouped time slots. Contains time slots collection.
     *
     * @class TimeFlexibleModel
     */
    return Backbone.Model.extend({

        defaults: {
            collection: '',
            time: '',
            date: '',
            provider_id: ''
        },

        toJSON: function (options) {
            var result = Backbone.Model.prototype.toJSON.apply(this, [options]);
            result.datetime = Date.parseMysqlDate(this.get('date') + ' ' + this.get('time'));

            // per-date client offset of the grouped slots (server 'time_diff'), for the hour/day label
            var collection = this.get('collection');
            var slot = collection && collection.find ? collection.find(function (model) { return model.has('time_diff'); }) : null;
            if (slot) {
                result.time_diff = slot.get('time_diff');
            }

            return result;
        }

    });

});
